import {
  Box,
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getColor } from "../../../style/color/color";
import { Close } from "@mui/icons-material";
import deleteIcon from "../../../assets/icon/Group_33961.png";
import TextInput from "../../../commanComponents/financialsnapshot/TextInput";
import CustomSnackbar from "../../../commanComponents/CustomerSnackbar";
import { format } from "date-fns";
import Labels from "../../../commanComponents/financialsnapshot/Labels";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { StyledDatePicker } from "../../../style/styleComponents/StyledDepositModel";
import { String } from "../../../constants/Strings";
import { fonts } from "../../../style/fonts/fonts";

const DepositModel = ({ Title, open, handlClose, onSubmit, values }) => {
  const [cards, setCards] = useState([
    { depositName: "", totalAmount: "", maturityDate: "" },
  ]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const handleAddMore = () => {
    setCards([
      ...cards,
      { depositName: "", totalAmount: "", maturityDate: "" },
    ]);
  };

  useEffect(() => {
    if (values && Array.isArray(values) && values.length > 0) {
      const formattedCards = values.map((card) => ({
        depositName: card.depositName || "",
        totalAmount: card.totalAmount || "",
        maturityDate: card.maturityDate ? parseDate(card.maturityDate) : null,
      }));

      setCards(formattedCards);
    } else {
      setCards([{ depositName: "", totalAmount: "", maturityDate: "" }]);
    }
  }, [values]);
  const parseDate = (dateString) => {
    const parse = dateString.split("-");
    if (parse.length === 3) {
      return new Date(`${parse[2]}-${parse[1]}-${parse[0]}`);
    }
    return null;
  };
  const handleFieldChange = (index, field, value) => {
    const newCards = [...cards];
    if (field === "maturityDate") {
      if (value instanceof Date && !isNaN(value.getTime())) {
        newCards[index][field] = value;
      } else {
        newCards[index][field] = null;
      }
    } else {
      newCards[index][field] = value;
      if (field === "depositName") {
        if (!/^[a-zA-Z\s]*$/.test(value)) {
          setSnackbarMessage(
            String.Dashboard.Boxes.deposit.depositnameValidationMessage
          );
          setSnackbarOpen(true);
          return;
        }
      }
      if (field === "totalAmount") {
        if (!/^\d+(\.\d+)?$/.test(value)) {
          setSnackbarMessage(
            String.Dashboard.Boxes.deposit.totalAmountValidationMessage
          );
          setSnackbarOpen(true);
          return;
        }
      }
    }
    setCards(newCards);
  };
  const handleDeleteCard = (index) => {
    if (cards.length > 1) {
      const newCards = cards.filter((_, cardIndex) => cardIndex !== index);
      setCards(newCards);
    }
  };
  const handleSave = () => {
    for (const card of cards) {
      if (!card.depositName || !card.totalAmount || !card.maturityDate) {
        setSnackbarMessage(String.Dashboard.Boxes.Allfields);
        setSnackbarOpen(true);
        return;
      }
    }

    const formattedCards = cards.map((card) => ({
      ...card,
      maturityDate: card.maturityDate
        ? format(card.maturityDate, "dd-MM-yyyy")
        : null,
    }));
    onSubmit(formattedCards);

    handlClose(false);
  };
  return (
    <Container sx={{ width: "100%" }}>
      <Dialog
        open={open}
        onClose={() => {
          handlClose(false);
        }}
        fullWidth
        sx={{
          width: "100%",
          maxWidth: "700px",
          maxHeight: "auto",
          overflowY: "auto",
          p: 1,
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
        }}
      >
        <DialogTitle
          sx={{
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: getColor.NeutralLightN60,
            textAlign: "center",
            position: "relative",
          }}
        >
          <Typography
            sx={{
              color: getColor.NeutralDark700,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              mt: "10px",
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            {Title}
          </Typography>
          <IconButton
            onClick={() => handlClose(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 2,
              cursor: "pointer",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            maxHeight: "400px",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Box
            sx={{
              mt: "40px",
              width: "100%",
              height: "auto",
            }}
          >
            {cards.map((card, index) => (
              <Card
                key={index}
                sx={{
                  width: "100%",
                  height: "100%",
                  mb: 3,
                  p: 3,
                  position: "relative",
                  mt: "20px",
                  overflow: "visible",
                }}
              >
                <IconButton
                  onClick={() => handleDeleteCard(index)}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: getColor.red,
                    cursor: "pointer",
                  }}
                >
                  <img src={deleteIcon} alt="delete" />
                </IconButton>
                <TextInput
                  label="Deposit Name"
                  value={card.depositName}
                  onChange={(e) =>
                    handleFieldChange(index, "depositName", e.target.value)
                  }
                />
                <TextInput
                  label="Total Amount"
                  value={card.totalAmount}
                  type={"number"}
                  onChange={(e) =>
                    handleFieldChange(index, "totalAmount", e.target.value)
                  }
                  inputPropss={true}
                />
                <Box
                  sx={{
                    marginTop: "10px",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Labels text={"Maturity Date"} />
                  <StyledDatePicker>
                    {" "}
                    <DatePicker
                      selected={card.maturityDate}
                      onChange={(date) =>
                        handleFieldChange(index, "maturityDate", date)
                      }
                      onFocus={(e) => e.target.blur()}
                      dateFormat="dd-MM-yyyy"
                      placeholderText="Select a date"
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      className=""
                      popperProps={{
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, 10],
                            },
                          },
                          {
                            name: "preventOverflow",
                            options: {
                              padding: 8,
                            },
                          },
                          {
                            name: "zIndex",
                            options: {
                              zIndex: 1000,
                            },
                          },
                        ],
                      }}
                    />
                  </StyledDatePicker>
                </Box>
              </Card>
            ))}
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", flexDirection: "column", p: 1, mt: "10px" }}
        >
          <Typography
            variant="body1"
            onClick={handleAddMore}
            color={getColor.red}
            sx={{
              fontSize: "1.2rem",
              mb: "20px",
              mt: "10px",
              cursor: "pointer",
            }}
            component={"div"}
          >
            + Add More
          </Typography>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              backgroundColor: getColor.ColorButtonPrimarysurface,
              width: "200px",
              mb: "20px",
              borderRadius: 4,
              textTransform: "inherit",
            }}
          >
            {String.Dashboard.Boxes.saveButton}
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={String.ErrorSeverity}
      />
    </Container>
  );
};

export default DepositModel;
